export default __webpack_public_path__ + "static/media/SopLocationIcon.fc2bd357.svg";